import { BaseService } from '../../../infra/base.service'
import { FormV2FormsRepository } from './form-v2-forms.repository'
import type { FormV2Form } from './form-v2-form'

export class FormV2FormsService extends BaseService<FormV2Form> {
    constructor(private rep: FormV2FormsRepository) {
        super(rep)
    }

    async publicGetOne(formV2FormLinkId: string, token: string) {
        return await this.rep.publicGetOne(formV2FormLinkId, token)
    }

    async publicUpdate(formV2FormLinkId: string, token: string, dto: Partial<FormV2Form>) {
        return await this.rep.publicUpdate(formV2FormLinkId, token, dto)
    }

    async publicUploadFile(formV2FormLinkId: string, token: string, content: string) {
        return await this.rep.publicUploadFile(formV2FormLinkId, token, content)
    }

    async publicGetSignatureReport(formV2FormLinkId: string, token: string) {
        return await this.rep.publicGetSignatureReport(formV2FormLinkId, token)
    }

    async publicStartSigning(formV2FormLinkId: string, token: string) {
        return await this.rep.publicStartSigning(formV2FormLinkId, token)
    }

    async publicGetContinueSigningLink(formV2FormLinkId: string, token: string) {
        return await this.rep.publicGetContinueSigningLink(formV2FormLinkId, token)
    }

    async startSigning(formV2FormId: string, mode: number) {
        return await this.rep.startSigning(formV2FormId, mode)
    }

    async stopSigning(formV2FormId: string) {
        return await this.rep.stopSigning(formV2FormId)
    }

    async dynamicTableAddRow(formV2FormId: string, blockId: string, timezoneOffsetMinutes: number) {
        return await this.rep.dynamicTableAddRow(formV2FormId, blockId, timezoneOffsetMinutes)
    }

    async dynamicTableSignRowInPerson(formV2FormId: string, dto: { blockId: string; rowId: string; columnId: string; imageDataUrl: string }) {
        return await this.rep.dynamicTableSignRowInPerson(formV2FormId, dto)
    }

    async dynamicTableCreateRowSignLink(formV2FormId: string, dto: { blockId: string; rowId: string; columnId: string }) {
        return await this.rep.dynamicTableCreateRowSignLink(formV2FormId, dto)
    }

    async findLastEmissionsFromPerson(personId: string, formV2TemplateIds: string[]) {
        return await this.rep.findLastEmissionsFromPerson(personId, formV2TemplateIds)
    }

    async publicGetRowSign(token: string) {
        return await this.rep.publicGetRowSign(token)
    }

    async publicSubmitRowSign(token: string, imageDataUrl: string) {
        return await this.rep.publicSubmitRowSign(token, imageDataUrl)
    }
}
